import {
  likeAiResistantHomework,
  unlikeAiResistantHomework,
  useDeleteAiResistantHomework,
  useGetTopAiResistantHomework,
  getGetTopAiResistantHomeworkQueryKey,
  useGetUserAiResistantHomework,
  getGetUserAiResistantHomeworkQueryKey,
} from "@packages/api/madlenAPI";
import { AiHomeworkIdeaCard } from "../../components/ai-resistant-homework-ideas/AiHomeworkIdeaCard";
import GenericToolPage from "../../components/tool_components/GenericToolPage";
import { BaseTeacherToolResponseDtoStatus } from "@packages/api/madlenAPI.schemas";
import i18n from "@packages/i18n/config";
interface HomeworkIdea {
  id: number;
  imageUrl?: string;
  videoUrl?: string;
  prompt?: string;
  title?: string;
  authorName?: string;
  likeCount?: number;
  courseName?: string;
  gradeLevel?: number;
  didUserLiked?: boolean;
  description?: string;
  explanation?: string;
  lessonDescription?: string;
  reportIdeas?: any[];
  authorId?: string;
  createdAt?: string;
  status?: BaseTeacherToolResponseDtoStatus;
  isEditable?: boolean;
  contentLanguage?: string;
}

interface ExtendedTool extends HomeworkIdea {
  id: number;
  imageUrl?: string;
  videoUrl?: string;
  prompt?: string;
  title?: string;
  authorName?: string;
  likeCount?: number;
  courseName?: string;
  gradeLevel?: number;
  didUserLiked?: boolean;
  description?: string;
}

const formatHomeworkIdea = (idea: HomeworkIdea) => ({
  id: idea.id?.toString() ?? "",
  imageUrl: idea.imageUrl || "",
  videoUrl: idea.videoUrl || "",
  title: idea.title || "",
  topic: idea.title || idea.prompt || "",
  subject: idea.courseName || "",
  gradeLevel: idea.gradeLevel || 0,
  duration: "45",
  difficulty: "medium",
  description: idea.lessonDescription || "",
  ideas: idea.reportIdeas || [],
  authorName: idea.authorName || "",
  authorId: idea.authorId?.toString() || "",
  likeCount: idea.likeCount || 0,
  didUserLiked: idea.didUserLiked || false,
  createdAt: idea.createdAt || "",
  status: idea.status || "",
  isEditable: idea.isEditable || false,
  contentLanguage: idea.contentLanguage || i18n.language,
});

const HomeworkIdeaDetailComponent = ({ tool }: { tool: ExtendedTool }) => {
  return (
    <AiHomeworkIdeaCard
      isEditable={formatHomeworkIdea(tool).isEditable}
      homeworkIdea={formatHomeworkIdea(tool)}
    />
  );
};

const AiResistantHomeworkIdeaView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserAiResistantHomework}
      useDeleteTool={useDeleteAiResistantHomework}
      getGetToolsQueryKey={getGetUserAiResistantHomeworkQueryKey}
      useGetTopTools={useGetTopAiResistantHomework}
      likeTool={likeAiResistantHomework}
      unlikeTool={unlikeAiResistantHomework}
      getGetTopToolsQueryKey={getGetTopAiResistantHomeworkQueryKey}
      toolType="aiHomeworkIdeas"
      toolPath="ai-resistant-homework-ideas"
      DetailComponent={HomeworkIdeaDetailComponent}
      colors={{
        light: "from-teal-600 to-teal-600",
        dark: "dark:from-emerald-400 dark:to-teal-400",
        iconBg: "bg-emerald-100 dark:bg-emerald-900/50",
        iconColor: "text-emerald-600 dark:text-emerald-400",
        hover: "hover:bg-emerald-50 dark:hover:bg-emerald-900/20",
      }}
      toolColor="teal"
      gradientColor="red"
    />
  );
};

export default AiResistantHomeworkIdeaView;
